/**
 * FERP Portal - Alert Severity Configuration
 *
 * Centralized UI configuration for alert severity levels.
 * The frontend is DUMB - it only provides UI styling for backend-defined values.
 *
 * Source of truth: backend GraphQL schema
 * Generated types: generated/graphql.ts
 */

import {
  IconAlertTriangle,
  IconAlertCircle,
  IconInfoCircle,
  IconBellRinging,
} from '@tabler/icons-react';

export const ALERT_SEVERITY_UI_CONFIG = {
  INFO: { color: 'blue', icon: IconInfoCircle, label: 'Info' },
  WARNING: { color: 'yellow', icon: IconAlertTriangle, label: 'Warning' },
  ERROR: { color: 'orange', icon: IconAlertCircle, label: 'Error' },
  CRITICAL: { color: 'red', icon: IconBellRinging, label: 'Critical' },
} as const;

export type AlertSeverity = keyof typeof ALERT_SEVERITY_UI_CONFIG;
